export const formatDate = (date: number | null | undefined): string => {
  const timestamp = date ?? 0;

  const format = new Date(timestamp * 1000);

  const year = format.getFullYear();
  const month = format.getMonth() + 1;
  const day = format.getDate();
  const hours = format.getHours();
  const minutes = format.getMinutes();

  return `${day}/${month}/${year} ${hours}:${minutes}`;
};
